import { Button, Tooltip } from '@mui/material'
import { memo } from 'react'
import { getFieldId } from '../utils/utils'
import { extractDisplayName } from '../../../utility/fileUtil'

export const FileUploadField = ({
  id,
  field,
  value,
  onChange,
  className = '',
  label = null,
  placeholder = null,
  helperText,
  disabled = false,
  tableField = false,
  inputSx = {},
  ...props
}) => {
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <Tooltip title={helperText}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          component="label"
          fullWidth
          className={className}
          sx={{
            height: 35,
            border: disabled ? '1px solid #a7a7a7' : helperText ? '1px solid #d32f2f' : null,
            color: disabled ? '#a7a7a7' : null,
            ...inputSx,
          }}
          {...props}
        >
          {tableField ? 'File' : placeholder}
          <input
            placeholder={placeholder}
            hidden
            type="file"
            disabled={disabled}
            name={getFieldId(id)}
            value={extractDisplayName(value)}
            onChange={onChange}
            id={getFieldId(id)}
          />
        </Button>
      </Tooltip>
    </div>
  )
}

export default memo(
  FileUploadField,
  (prevProps, nextProps) =>
    prevProps.value == nextProps.value &&
    prevProps.helperText === nextProps.helperText &&
    prevProps.disabled === nextProps.disabled,
)
